exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#support-page .supportinfo-page {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  -webkit-transform: translate(-50%, -50%);\r\n          transform: translate(-50%, -50%);\r\n  width: 750px;\r\n  background: #fff;\r\n  margin: 2em auto 2em;\r\n  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.3);\r\n  border-radius: 5px;\r\n  box-sizing: border-box;\r\n\r\n}\r\n\r\n#support-page .form-head {\r\n  background: #dfe2e4;\r\n  padding: 10px 0;\r\n\r\n}\r\n#support-page .support-content {\r\n  width: 650px;\r\n  height: 450px;\r\n  padding: 10px;\r\n  text-align: left;\r\n  margin-left: 50px;\r\n  margin-top: 10px;\r\n  overflow: auto;\r\n\r\n}\r\n\r\n\r\n#support-page .btn-primary {\r\n  padding: 14px 12px;\r\n  background: #a2cc38;\r\n  border-radius: 5px;\r\n  border: 0px solid;\r\n  width: 138px;\r\n  height: 48px;\r\n  font-family: Bitter;\r\n  font-size: 15px;\r\n \r\n}\r\n\r\n.button-wrapper {\r\n  text-align: center;\r\n  padding-bottom: 2em;\r\n  padding-top: 2em;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/authentication/cannotregister/cannotregister.component.css
// module id = ../../../../../src/app/authentication/cannotregister/cannotregister.component.css
// module chunks = main